export default "__VITE_ASSET__DwFMHRsn__"